export var FeatureIconTypes;
(function (FeatureIconTypes) {
    FeatureIconTypes["GROSS_WEIGHT_CAPACITY_TYPE"] = "grossWeightCapacityType";
    FeatureIconTypes["MAXIMUM_POWER_TYPE"] = "maximumPowerType";
    FeatureIconTypes["USABLE_CAB_TO_AXLE_TYPE"] = "usableCabToAxleType";
    FeatureIconTypes["VEHICLE_GROSS_WEIGHT_TYPE"] = "vehicleGrossWeightType";
    FeatureIconTypes["DIMENSIONS_FROM_WHEEL_TRACK_TYPE"] = "dimensionsFromWheelTrackType";
})(FeatureIconTypes || (FeatureIconTypes = {}));
//# sourceMappingURL=FeatureIconTypes.js.map